// axios.js – API Kommunikation über ENV gesteuert

import axios from "axios";
import router from "../routes/index";

const API_BASE_URL = import.meta.env.VITE_API_URL;   // z. B. https://domain.tld/

const instance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  withCredentials: false,
});

// --- Request Interceptor ---
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");

    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// --- Response Interceptor ---
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const path = router.currentRoute.value.path;

    const isPasswordResetFlow =
      path.startsWith("/PasswordReset") ||
      path.startsWith("/Auth") === false;

    if (status === 401) {
      localStorage.removeItem("access_token");

      if (!isPasswordResetFlow) {
        router.push({ name: "Auth" });
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
